import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-baeae19c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_3 = { class: "CompanyForm" }
const _hoisted_4 = { class: "CompanyForm__inputs" }
const _hoisted_5 = { class: "flex items-center gap-4" }
const _hoisted_6 = { class: "flex items-center justify-center" }
const _hoisted_7 = { class: "CompanyForm__checkboxes" }
const _hoisted_8 = { class: "flex justify-end items-center mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_company_schedules = _resolveComponent("company-schedules")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_page_title, {
        title: _ctx.isCreate ? 'Добавление компании' : 'Редактирование компании'
      }, null, 8, ["title"]),
      _createVNode(_component_the_button, {
        class: "second text small",
        onClick: _ctx.emitCancel
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createTextVNode(" Отмена ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_the_input, {
          placeholder: "Название компании",
          value: _ctx.state.name,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.name) = $event)),
          "is-invalid": _ctx.state_form$.name.$error,
          "validation-errors": _ctx.state_form$.name.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          placeholder: "Сокращенное название компании",
          value: _ctx.state.short_name,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.short_name) = $event)),
          "is-invalid": _ctx.state_form$.short_name.$error,
          "validation-errors": _ctx.state_form$.short_name.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          placeholder: "БИН компании",
          value: _ctx.state.bin,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.bin) = $event)),
          "is-invalid": _ctx.state_form$.bin.$error,
          "validation-errors": _ctx.state_form$.bin.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          placeholder: "КБЕ компании",
          value: _ctx.state.kbe,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.kbe) = $event)),
          "is-invalid": _ctx.state_form$.kbe.$error,
          "validation-errors": _ctx.state_form$.kbe.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_the_select, {
            class: "flex-1",
            value: _ctx.state.type_id,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.type_id) = $event)),
            placeholder: "Выберите тип компании",
            "is-invalid": _ctx.state_form$.type_id.$error,
            "validation-errors": _ctx.state_form$.type_id.$errors,
            loading: false,
            options: _ctx.CompaniesTypes,
            "search-by": "name",
            label: "name"
          }, null, 8, ["value", "is-invalid", "validation-errors", "options"]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_checkbox, {
              class: "mt-4",
              label: "ЧЛ",
              value: _ctx.state.isChl,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.isChl) = $event))
            }, null, 8, ["value"])
          ])
        ]),
        _createVNode(_component_the_select, {
          value: _ctx.state.country_id,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.country_id) = $event)),
          placeholder: "Выберите страну",
          "is-invalid": _ctx.state_form$.country_id.$error,
          "validation-errors": _ctx.state_form$.country_id.$errors,
          loading: _ctx.data_state.countries.is_loading,
          options: _ctx.data_state.countries.list,
          failed: _ctx.data_state.countries.is_failed,
          "error-text": "При получении списка стран произошла ошибка",
          "search-by": "title",
          "select-by": "id",
          label: "title",
          "infinite-scroll": "",
          onRefresh: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadCountries(_ctx.data_state.countries.pagination.current_page))),
          onLoadmore: _cache[8] || (_cache[8] = ($event: any) => (_ctx.loadMoreCountries(_ctx.data_state.countries.pagination.current_page + 1))),
          onSearch: _ctx.searchCountries,
          onOptionBySearch: _ctx.unshiftFindedCountry
        }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onSearch", "onOptionBySearch"]),
        _createVNode(_component_the_select, {
          value: _ctx.state.manager_id,
          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.manager_id) = $event)),
          placeholder: "Выберите менеджера",
          "is-invalid": _ctx.state_form$.manager_id.$error,
          "validation-errors": _ctx.state_form$.manager_id.$errors,
          loading: _ctx.data_state.managers.is_loading,
          options: _ctx.data_state.managers.list,
          failed: _ctx.data_state.managers.is_failed,
          "error-text": "При получении списка менеджеров произошла ошибка",
          "search-by": "name",
          "select-by": "id",
          label: "name",
          onRefresh: _cache[10] || (_cache[10] = ($event: any) => (_ctx.loadManagers(_ctx.data_state.managers.pagination.current_page))),
          onSearch: _ctx.searchManagers,
          onLoadmore: _cache[11] || (_cache[11] = ($event: any) => (_ctx.loadMoreManagers(_ctx.data_state.managers.pagination.current_page + 1))),
          onOptionBySearch: _ctx.unshiftFindedManager,
          "infinite-scroll": ""
        }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onSearch", "onOptionBySearch"]),
        _createVNode(_component_the_input, {
          placeholder: "Юридический адрес",
          value: _ctx.state.jur_address,
          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.jur_address) = $event)),
          "is-invalid": _ctx.state_form$.jur_address.$error,
          "validation-errors": _ctx.state_form$.jur_address.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          placeholder: "Фактический адрес",
          value: _ctx.state.fact_address,
          "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.fact_address) = $event)),
          "is-invalid": _ctx.state_form$.fact_address.$error,
          "validation-errors": _ctx.state_form$.fact_address.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          placeholder: "Номер свидетельства о постановке на учёт НДС",
          value: _ctx.state.nds,
          "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.nds) = $event)),
          "is-invalid": _ctx.state_form$.nds.$error,
          "validation-errors": _ctx.state_form$.nds.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          placeholder: "Дата свидетельства о регистрации НДС",
          type: "date",
          value: _ctx.state.ndsRegisterDate,
          "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.ndsRegisterDate) = $event))
        }, null, 8, ["value"]),
        _createVNode(_component_the_input, {
          placeholder: "Серия НДС",
          value: _ctx.state.ndsSeries,
          "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.ndsSeries) = $event))
        }, null, 8, ["value"]),
        _createVNode(_component_the_input, {
          placeholder: "Счёт",
          value: _ctx.state.bank_account,
          "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.bank_account) = $event)),
          "is-invalid": _ctx.state_form$.bank_account.$error,
          "validation-errors": _ctx.state_form$.bank_account.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          placeholder: "Банк",
          value: _ctx.state.bank,
          "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.bank) = $event)),
          "is-invalid": _ctx.state_form$.bank.$error,
          "validation-errors": _ctx.state_form$.bank.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          placeholder: "БИК",
          value: _ctx.state.bik,
          "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.bik) = $event)),
          "is-invalid": _ctx.state_form$.bik.$error,
          "validation-errors": _ctx.state_form$.bik.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          placeholder: "Номер договора",
          value: _ctx.state.contract_number,
          "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.contract_number) = $event)),
          "is-invalid": _ctx.state_form$.contract_number.$error,
          "validation-errors": _ctx.state_form$.contract_number.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          placeholder: "Дата договора",
          type: "date",
          value: _ctx.state.contract_date,
          "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.contract_date) = $event))
        }, null, 8, ["value"]),
        _createVNode(_component_the_input, {
          placeholder: "Контактное имя",
          value: _ctx.state.contact_name,
          "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.contact_name) = $event)),
          "is-invalid": _ctx.state_form$.contact_name.$error,
          "validation-errors": _ctx.state_form$.contact_name.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          placeholder: "Контактный телефон",
          value: _ctx.state.contact_phone,
          "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.contact_phone) = $event)),
          "is-invalid": _ctx.state_form$.contact_phone.$error,
          "validation-errors": _ctx.state_form$.contact_phone.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          placeholder: "Контактный email",
          value: _ctx.state.contact_email,
          "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.contact_email) = $event)),
          "is-invalid": _ctx.state_form$.contact_email.$error,
          "validation-errors": _ctx.state_form$.contact_email.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        (_ctx.isCreate)
          ? (_openBlock(), _createBlock(_component_the_select, {
              key: 0,
              value: _ctx.state.initiatorId,
              "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.initiatorId) = $event)),
              placeholder: "Инициатор",
              "is-invalid": _ctx.state_form$.initiatorId.$error,
              "validation-errors": _ctx.state_form$.initiatorId.$errors,
              loading: _ctx.data_state.initiators.is_loading,
              options: _ctx.data_state.initiators.list,
              failed: _ctx.data_state.initiators.is_failed,
              "error-text": "При получении списка инициаторов произошла ошибка",
              "search-by": "name",
              "select-by": "id",
              label: "name",
              onRefresh: _cache[26] || (_cache[26] = ($event: any) => (_ctx.loadInitiators(_ctx.data_state.initiators.pagination.current_page))),
              onLoadmore: _cache[27] || (_cache[27] = ($event: any) => (
                        _ctx.loadMoreInitiators(_ctx.data_state.initiators.pagination.current_page + 1)
                    )),
              onSearch: _ctx.searchInitiators,
              onOptionBySearch: _ctx.unshiftFindedInitiator,
              "infinite-scroll": ""
            }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onSearch", "onOptionBySearch"]))
          : _createCommentVNode("", true),
        _createVNode(_component_the_select, {
          value: _ctx.state.billingPeriodId,
          "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.billingPeriodId) = $event)),
          placeholder: "Периодичность выставления счетов",
          loading: _ctx.data_state.billing_periods.is_loading,
          options: _ctx.data_state.billing_periods.list,
          failed: _ctx.data_state.billing_periods.is_failed,
          "error-text": "При получении списка периодов произошла ошибка",
          "select-by": "id",
          label: "title",
          onRefresh: _cache[29] || (_cache[29] = ($event: any) => (_ctx.loadBillingPeriods(1)))
        }, null, 8, ["value", "loading", "options", "failed"]),
        _createVNode(_component_the_select, {
          value: _ctx.state.businessModelId,
          "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.state.businessModelId) = $event)),
          placeholder: "Бизнес модель",
          loading: _ctx.data_state.business_models.is_loading,
          options: _ctx.data_state.business_models.list,
          failed: _ctx.data_state.business_models.is_failed,
          "error-text": "При получении списка бизнес моделей произошла ошибка",
          "select-by": "id",
          label: "name",
          "is-invalid": _ctx.state_form$.businessModelId.$error,
          "validation-errors": _ctx.state_form$.businessModelId.$errors,
          onRefresh: _ctx.loadBusinessModels,
          onChange: _ctx.initializeSchedules
        }, null, 8, ["value", "loading", "options", "failed", "is-invalid", "validation-errors", "onRefresh", "onChange"]),
        _createVNode(_component_the_select, {
          value: _ctx.state.companySourceId,
          "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.companySourceId) = $event)),
          placeholder: "Признак",
          loading: _ctx.data_state.company_sources.is_loading,
          options: _ctx.data_state.company_sources.list,
          failed: _ctx.data_state.company_sources.is_failed,
          "is-invalid": _ctx.state_form$.companySourceId.$error,
          "validation-errors": _ctx.state_form$.companySourceId.$errors,
          onRefresh: _ctx.loadCompanySources
        }, null, 8, ["value", "loading", "options", "failed", "is-invalid", "validation-errors", "onRefresh"]),
        _createVNode(_component_the_select, {
          placeholder: "Выберите бухгалтера",
          value: _ctx.state.accountant_id,
          "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.state.accountant_id) = $event)),
          loading: _ctx.data_state.accountants.is_loading,
          options: _ctx.data_state.accountants.list,
          failed: _ctx.data_state.accountants.is_failed,
          "error-text": "При получении списка бухгалтеров произошла ошибка",
          "search-by": "name",
          "select-by": "id",
          label: "name",
          "infinite-scroll": "",
          onRefresh: _cache[33] || (_cache[33] = ($event: any) => (_ctx.loadAccountants(_ctx.data_state.accountants.pagination.current_page))),
          onLoadmore: _cache[34] || (_cache[34] = ($event: any) => (
                        _ctx.loadMoreAccountants(_ctx.data_state.accountants.pagination.current_page + 1)
                    )),
          onSearch: _ctx.searchAccountants,
          onOptionBySearch: _ctx.unshiftFindedAccountant,
          "is-invalid": _ctx.state_form$.accountant_id.$error,
          "validation-errors": _ctx.state_form$.accountant_id.$errors
        }, null, 8, ["value", "loading", "options", "failed", "onSearch", "onOptionBySearch", "is-invalid", "validation-errors"]),
        (_ctx.isCreate)
          ? (_openBlock(), _createBlock(_component_the_select, {
              key: 1,
              placeholder: "Тариф",
              value: _ctx.state.shipmentTariffId,
              "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.state.shipmentTariffId) = $event)),
              options: _ctx.BILLING_TARIFF_TYPES
            }, null, 8, ["value", "options"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_checkbox, {
          label: "Биллинг",
          value: _ctx.state.billingEnabled,
          "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.state.billingEnabled) = $event))
        }, null, 8, ["value"]),
        (!_ctx.isUpdate)
          ? (_openBlock(), _createBlock(_component_checkbox, {
              key: 0,
              label: "Стандартный договор",
              value: _ctx.state.isStandardContract,
              "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.state.isStandardContract) = $event)),
              class: "ml-3"
            }, null, 8, ["value"]))
          : _createCommentVNode("", true),
        _createVNode(_component_checkbox, {
          class: "ml-3",
          label: "Приоритетный клиент",
          value: _ctx.state.priority,
          "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.state.priority) = $event)),
          "return-integer": ""
        }, null, 8, ["value"]),
        (_ctx.isUpdate)
          ? (_openBlock(), _createBlock(_component_checkbox, {
              key: 1,
              label: "Подразделение",
              value: _ctx.state.isSubdivision,
              "onUpdate:value": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.state.isSubdivision) = $event)),
              class: "ml-3"
            }, null, 8, ["value"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.isCreate)
      ? (_openBlock(), _createBlock(_component_company_schedules, {
          key: 0,
          "is-business-model-selected": Boolean(_ctx.state.businessModelId),
          value: _ctx.state.schedules,
          onRemove: _ctx.onScheduleRemove,
          onAdd: _ctx.onScheduleAdd
        }, null, 8, ["is-business-model-selected", "value", "onRemove", "onAdd"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_the_button, {
        class: "small primary",
        type: "button",
        loading: _ctx.loading,
        onClick: _ctx.emitManager
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.isCreate ? 'Создать' : 'Редактировать'), 1)
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ])
  ]))
}